import React from "react";
import Fade from "react-reveal/Fade";
import { Link } from "react-router-dom";
import heroimg from "../images/banner-image.png";

const Hero = () => {
	return (
		<div className=" text-white bg-dark pb-5">
			<div className="container">
				<div className="row d-flex align-items-center">
    
					<div className="col-md-6  order-sm-2">
						<img
							style={{ width: "100%" }}
							src={heroimg}
							className="heroimg"
							alt=""
						/>
					</div>
 
					<div className="col-md-6">
						<Fade left >
							<h5 className="diaplay-6">Hello,I&apos;m</h5>
							<h1 className="display-2">Fahim Alif</h1>
							<h6 className="display-6">I&apos;m a Front-end Developer</h6>
							<p className="display-6">
                A passionate developer committed to life-long learning. I
                develop web applications whether front-end or back-end. My core
                skills are based on Javascript and love to code in Javascript. I
                am available for any kind of job opportunity that suits my
                interests.
							</p>
						</Fade>

						<div className="d-flex">
							<Link to="/aboutme">
								<button className="btn btn-success mr-2 text-decoration-none text-white">
                  About me
								</button>
							</Link>
							<Link to="/contact">
								<button className="btn btn-outline-success text-decoration-none text-white">
                  Get in touch
								</button>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Hero;
